import { useQuery } from 'react-query';
import { useAxios } from 'shared/hooks';
export var useMemberPlannedFollowUp = function (schemas, memberId, disabled) {
    var joinedSchemas = "?schemas[]=".concat(schemas.join('&schemas[]='));
    var axios = useAxios();
    return useQuery(['member-planned-followup', memberId], function () {
        return axios.get("api/v1/members/".concat(memberId, "/planned_followup").concat(joinedSchemas));
    }, {
        enabled: !!schemas || disabled,
        refetchOnMount: false,
        select: function (response) { var _a; return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data; },
    });
};
